import { axiosInstance } from './axios-instance';

export interface ApiRequestConfig {
    params?: Record<string, any>;
    headers?: Record<string, string>;
    timeout?: number;
    disableGlobalError?: boolean;
    onCustomError?: (error: any) => void;
}

/**
 * Functional API client using Axios.
 * This handles communication with the backend without using classes or interfaces.
 */
export const apiClient = {
    get: async <T>(url: string, config?: ApiRequestConfig): Promise<T> => {
        return axiosInstance.get<any, T>(url, config as any);
    },

    post: async <T>(url: string, data?: unknown, config?: ApiRequestConfig): Promise<T> => {
        return axiosInstance.post<any, T>(url, data, config as any);
    },

    put: async <T>(url: string, data?: unknown, config?: ApiRequestConfig): Promise<T> => {
        return axiosInstance.put<any, T>(url, data, config as any);
    },

    patch: async <T>(url: string, data?: unknown, config?: ApiRequestConfig): Promise<T> => {
        return axiosInstance.patch<any, T>(url, data, config as any);
    },

    delete: async <T>(url: string, config?: ApiRequestConfig): Promise<T> => {
        return axiosInstance.delete<any, T>(url, config as any);
    },
};
